module.exports = __webpack_public_path__ + "img/vol05_cup01_label01.2a3f9707.png";